export const crop = {
    state: {
        status: 'idle',
        crop: null
    },
    mutations: {
        SET_CROP_STATUS(state, status) {
            state.status = status
        },
        SET_CROP(state, crop) {
            state.crop = crop
        }
    },
    actions: {
        fetchCrop({ state, commit }, payload) {
            commit('SET_CROP', null)
            commit('SET_CROP_STATUS', 'loading')
            return this.$api.get(`/api/crops/${payload}.json`).then((response) => {
                commit('SET_CROP', response.data.data)
                commit('SET_CROP_STATUS', 'idle')
                return response.data.data
            }).catch(error => {
                // return Promise.reject(error)
                commit('SET_AGROFAG_STATUS', 'error')
                return Promise.reject(error)
            })
        }
    },
    getters: {
        cropStatus: (state) => {
            return state.status
        },
        crop: (state) => {
            if (state.crop) {
                return state.crop
            }
        }
    }
}
